import type { ApiError } from '@/types/api';

export interface ErrorDetails {
  message: string;
  requiredTokens?: number;
  currentBalance?: number;
  isTokenError?: boolean;
}

export function parseApiError(
  error: unknown,
  defaultMessage: string
): ErrorDetails {
  const apiError = error as ApiError;
  let message = defaultMessage;
  let requiredTokens: number | undefined;
  let currentBalance: number | undefined;
  let isTokenError = false;

  // Check for API error structure
  if (apiError.apiError?.errors?.[0]) {
    const firstError = apiError.apiError.errors[0];
    message = firstError.detail || firstError.title || message;

    // Check for token error metadata
    if (apiError.status === 402 && firstError.meta) {
      const meta = firstError.meta as {
        required_tokens?: number;
        current_balance?: number;
      };

      if (
        meta.required_tokens !== undefined &&
        meta.current_balance !== undefined
      ) {
        requiredTokens = meta.required_tokens;
        currentBalance = meta.current_balance;
        isTokenError = true;
        message = `Insufficient tokens: ${currentBalance} available, ${requiredTokens} required`;
      }
    }
  } else if (apiError.response?.data?.message) {
    // Fallback to response message
    message = apiError.response.data.message;
  } else if (apiError.message) {
    // Fallback to error message
    message = apiError.message;
  }

  return { message, requiredTokens, currentBalance, isTokenError };
}
